Object.defineProperty(exports,"__esModule",{value:true});var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}




var colors=[
"#252525",
"#525252",
"#737373",
"#969696",
"#bdbdbd",
"#d9d9d9",
"#f0f0f0"];


var charcoal="#252525";



var sansSerif="'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif";
var letterSpacing="normal";
var fontSize=14;



var baseProps={
width:450,
height:300,
padding:50,
colorScale:colors};




var baseLabelStyles={
fontFamily:sansSerif,
fontSize:fontSize,
letterSpacing:letterSpacing,
padding:10,
fill:charcoal,
stroke:"transparent"};


var centeredLabelStyles=(0,_assign3.default)({textAnchor:"middle"},baseLabelStyles);



var strokeLinecap="round";
var strokeLinejoin="round";exports.default=

{
area:(0,_assign3.default)({
style:{
data:{
fill:charcoal},

labels:centeredLabelStyles}},

baseProps),
axis:(0,_assign3.default)({
style:{
axis:{
fill:"transparent",
stroke:charcoal,
strokeWidth:1,
strokeLinecap:strokeLinecap,
strokeLinejoin:strokeLinejoin},

axisLabel:(0,_assign3.default)({},centeredLabelStyles,{
padding:25}),

grid:{
fill:"transparent",
stroke:"transparent",
pointerEvents:"none"},

ticks:{
fill:"transparent",
size:1,
stroke:"transparent"},

tickLabels:baseLabelStyles}},

baseProps),
bar:(0,_assign3.default)({
style:{
data:{
fill:charcoal,
padding:10,
strokeWidth:0,
width:8},

labels:baseLabelStyles}},

baseProps),
candlestick:(0,_assign3.default)({
style:{
data:{
stroke:charcoal,
strokeWidth:1},

labels:centeredLabelStyles},

candleColors:{
positive:"#ffffff",
negative:charcoal}},

baseProps),
chart:baseProps,
errorbar:(0,_assign3.default)({
style:{
data:{
fill:"transparent",
stroke:charcoal,
strokeWidth:2},

labels:centeredLabelStyles}},

baseProps),
group:(0,_assign3.default)({
colorScale:colors},
baseProps),
line:(0,_assign3.default)({
style:{
data:{
fill:"transparent",
stroke:charcoal,
strokeWidth:2},

labels:centeredLabelStyles}},

baseProps),
pie:{
style:{
data:{
padding:10,
stroke:"transparent",
strokeWidth:1},

labels:(0,_assign3.default)({},baseLabelStyles,{padding:20})},

colorScale:colors,
width:400,
height:400,
padding:50},

scatter:(0,_assign3.default)({
style:{
data:{
fill:charcoal,
stroke:"transparent",
strokeWidth:0},

labels:centeredLabelStyles}},

baseProps),
stack:(0,_assign3.default)({
colorScale:colors},
baseProps),
tooltip:{
style:(0,_assign3.default)({},centeredLabelStyles,{padding:5,pointerEvents:"none"}),
flyoutStyle:{
stroke:charcoal,
strokeWidth:1,
fill:"#f0f0f0",
pointerEvents:"none"},

cornerRadius:5,
pointerLength:10},

voronoi:(0,_assign3.default)({
style:{
data:{
fill:"transparent",
stroke:"transparent",
strokeWidth:0},

labels:(0,_assign3.default)({},centeredLabelStyles,{padding:5,pointerEvents:"none"}),
flyout:{
stroke:charcoal,
strokeWidth:1,
fill:"#f0f0f0",
pointerEvents:"none"}}},


baseProps),
legend:{
colorScale:colors,
style:{
data:{
type:"circle"},

labels:baseLabelStyles}}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-theme/grayscale.js
// module id = 1385
// module chunks = 0